import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import { useRussianPokerStore } from 'providers/RussianPokerProvider'
import { FC, useRef } from 'react'
import { useClickAway } from 'react-use'
import { useStore } from 'stores'
import { SoundOffIcon, SoundOnIcon } from '../Icons'
import { topBarIconHoverStyles } from '../Icons/styles'
import { VolumeSlider } from '../VolumeSlider'

const StyledIconSoundOff = styled(SoundOffIcon)`
  ${topBarIconHoverStyles}
`

const StyledIconSoundOn = styled(SoundOnIcon)`
  ${topBarIconHoverStyles}
`

const Button = styled.button`
  all: unset;
  display: flex;
  position: relative;
  cursor: pointer;

  /* Увеличенная область клика для мобильных устройств */
  &::after {
    content: '';
    position: absolute;
    top: -12px;
    left: -12px;
    right: -12px;
    bottom: -12px;
  }
`

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

const sizeIcon = {
  mobile: '11px',
  tablet: '19px',
  desktop: '19px',
}

export const ToggleSoundBtn: FC = observer(() => {
  const { uiStore: globalUIStore } = useStore()
  const {
    uiStore: { volume, toggleMute, showVolumePopup, setShowVolumePopup },
  } = useRussianPokerStore()

  const containerRef = useRef<HTMLDivElement>(null)
  const hasSound = volume > 0

  const { isTouchDevice } = globalUIStore

  const handleClick = () => {
    if (isTouchDevice) {
      toggleMute()
    } else {
      setShowVolumePopup(!showVolumePopup)
    }
  }

  useClickAway(containerRef, () => {
    if (!showVolumePopup || isTouchDevice) return
    setShowVolumePopup(false)
  })

  return (
    <Container ref={containerRef}>
      <Button type="button" onClick={handleClick}>
        {hasSound ? (
          <StyledIconSoundOn size={sizeIcon} />
        ) : (
          <StyledIconSoundOff size={sizeIcon} />
        )}
      </Button>
      {showVolumePopup && !isTouchDevice && <VolumeSlider />}
    </Container>
  )
})
